import { useApi } from '@omnipresentgroup/api';
import type { GetInvoiceReportResponseAPI } from '@omnipresentgroup/types';
import { useQuery } from '@tanstack/react-query';

import { API_BASE, API_PATH, INVOICE_REPORT_API_PATH } from '../constants';
import { transformGetInvoiceReportResponseFromAPI } from '../mappers';

export const getInvoiceReportKey = (companyId: string, invoiceId: string) => [
  API_PATH,
  companyId,
  'invoices',
  invoiceId,
];

export const useInvoiceReport = ({
  companyId,
  invoiceId,
  enabled,
}: {
  companyId: string;
  invoiceId: string;
  enabled?: boolean;
}) => {
  const { GET } = useApi();
  const query = useQuery({
    queryKey: getInvoiceReportKey(companyId, invoiceId),
    queryFn: () =>
      GET<GetInvoiceReportResponseAPI>(
        `${API_BASE}/${INVOICE_REPORT_API_PATH(companyId, invoiceId)}`,
        {},
      ),
    select: (data) => transformGetInvoiceReportResponseFromAPI(data),
    enabled: enabled || (!!companyId && !!invoiceId),
  });

  return query;
};
